import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const DemoExample = () => {
  const demo = {
    title: "Primer AI Agenta Podrške",
    description: "Sistem baziran na veštačkoj inteligenciji koji odgovara na upite kupaca sa 98.7% preciznosti u realnom vremenu.",
    metrics: {
      vreme_odgovora: "ispod 3 sekunde",
      preciznost: "98.7%",
      usteda_troskova: "-75%",
      reseno_tiketa: "2,400/dan",
      dostupnost: "99.9%"
    }
  };

  const [isVideoOpen, setIsVideoOpen] = useState(false);

  return (
    <> {/* Koristimo Fragment da bismo mogli da dodamo modal van section-a */}
      <section id="demo" className="py-20 bg-gradient-to-br from-gray-800 via-gray-900 to-gray-800 relative overflow-hidden">
        {/* Animirane zvezdice u pozadini (ostaje isto) */}
        <div className="absolute inset-0">
          {/* Male zvezdice */}
          {[...Array(40)].map((_, i) => (
            <motion.div
              key={i}
              className="absolute w-0.5 h-0.5 bg-white rounded-full"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
              }}
              animate={{
                opacity: [0.2, 1, 0.2],
                scale: [0.5, 1.2, 0.5],
              }}
              transition={{
                duration: 3 + Math.random() * 2,
                repeat: Infinity,
                delay: Math.random() * 5,
                ease: "easeInOut"
              }}
            />
          ))}

          {/* Srednje zvezde sa bojom */}
          {[...Array(20)].map((_, i) => (
            <motion.div
              key={`med-${i}`}
              className="absolute w-1 h-1 bg-blue-400/50 rounded-full blur-[0.5px]"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
              }}
              animate={{
                opacity: [0.1, 0.8, 0.1],
                scale: [0.8, 1.5, 0.8],
              }}
              transition={{
                duration: 4 + Math.random() * 2,
                repeat: Infinity,
                delay: Math.random() * 4,
                ease: "easeInOut"
              }}
            />
          ))}

          {/* Leteće zvezdice */}
          {[...Array(8)].map((_, i) => (
            <motion.div
              key={`flying-${i}`}
              className="absolute w-0.5 h-0.5 bg-cyan-400/70 rounded-full"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
              }}
              animate={{
                x: [0, Math.random() * 200 - 100],
                y: [0, Math.random() * 200 - 100],
                opacity: [0, 1, 0],
                scale: [0, 1.5, 0],
              }}
              transition={{
                duration: 6 + Math.random() * 4,
                repeat: Infinity,
                delay: Math.random() * 6,
                ease: "easeInOut"
              }}
            />
          ))}

          {/* Shooting stars */}
          {[...Array(3)].map((_, i) => (
            <motion.div
              key={`shooting-${i}`}
              className="absolute w-0.5 h-px bg-gradient-to-r from-white to-transparent"
              style={{
                left: `${Math.random() * 30}%`,
                top: `${Math.random() * 50}%`,
                width: '40px'
              }}
              animate={{
                x: [0, 150],
                y: [0, 75],
                opacity: [0, 1, 0],
              }}
              transition={{
                duration: 1.2,
                repeat: Infinity,
                delay: 8 + Math.random() * 12,
                ease: "easeOut"
              }}
            />
          ))}

          {/* Svetlosni efekat */}
          <motion.div
            className="absolute top-1/4 right-1/3 w-64 h-64 bg-gradient-radial from-blue-500/5 to-transparent rounded-full blur-2xl"
            animate={{
              scale: [1, 1.3, 1],
              opacity: [0.2, 0.4, 0.2],
            }}
            transition={{
              duration: 8,
              repeat: Infinity,
              ease: "easeInOut"
            }}
          />
        </div>

        {/* Glavni sadržaj */}
        <div className="max-w-3xl mx-auto px-4 relative z-10">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-4">Primer u radu</h2>
            <p className="text-xl text-gray-300">
              Pogledajte kako naši AI agenti transformišu korisničku podršku
            </p>
          </div>

          <motion.div
            className="bg-gradient-to-b from-gray-900 to-black rounded-lg p-6 border border-gray-700 hover:border-blue-500/50 transition-all duration-300 max-w-lg mx-auto"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6 }}
          >
            <h3 className="text-2xl font-semibold mb-4 text-blue-400 text-center">{demo.title}</h3>
            <p className="text-gray-300 mb-6 text-center">{demo.description}</p>

            <div className="grid grid-cols-2 gap-4 mb-6">
              {Object.entries(demo.metrics).map(([key, value]) => (
                <div key={key} className="text-center">
                  <div className="text-xl font-bold text-white mb-1">{value}</div>
                  <div className="text-gray-400 capitalize text-xs">{key.replace('_', ' ')}</div>
                </div>
              ))}
            </div>

            <motion.button
              onClick={() => setIsVideoOpen(true)}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 px-4 rounded-lg transition-colors font-semibold text-center block"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              Pogledaj Demo
            </motion.button>
          </motion.div>
        </div>
      </section>

      {/* ====================================================================== */}
      {/* ===== KORIGOVANI VIDEO MODAL SE NALAZI OVDE ISPOD ====================== */}
      {/* ====================================================================== */}
      <AnimatePresence>
        {isVideoOpen && (
          <motion.div
            className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 p-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setIsVideoOpen(false)}
          >
            <motion.div
              className="bg-black p-1 rounded-lg shadow-2xl relative w-[90vw] md:w-[80vw] max-w-6xl aspect-video"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ type: "spring", stiffness: 260, damping: 20 }}
              exit={{ scale: 0.8, opacity: 0 }}
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={() => setIsVideoOpen(false)}
                className="absolute -top-3 -right-3 bg-white text-black rounded-full w-8 h-8 flex items-center justify-center text-xl font-bold z-10 hover:bg-gray-200 transition-colors"
              >
                &times;
              </button>
              <video
                src="/videos/demo.mp4" // <<< PROVERI DA LI JE PUTANJA TAČNA
                className="w-full h-full rounded-md"
                controls
                autoPlay
                loop
                playsInline
              >
                Your browser does not support the video tag.
              </video>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default DemoExample;